import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import axios from "axios";
import { apiKey } from "../../config/config";

function HeroSlider({ loader }) {
  const outlet = JSON.parse(localStorage.getItem("rms-outlet"));
  const [banners, setBanners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/customer/banners`, {
        params: {
          outletId: outlet?.outlet.id,
          status: "active"
        },
      })
      .then((res) => {
        setBanners(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [outlet?.outlet.id]);

  if (isLoading) {
    return (
      <div className="w-full grid place-items-center h-72">
        <img src={loader?.loader_url} className="w-16" alt="loading..." />
      </div>
    );
  }
  return (
    <section>
      <div className="max-w-7xl w-[90%] mx-auto rounded-2xl overflow-clip">
        <Swiper
          navigation={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          loop={true}
          modules={[Navigation, Autoplay]}
          className="mySwiper"
        >
          {banners.map((banner, index) => (
            <SwiperSlide key={index}>
              <div className="rounded-2xl overflow-clip">
                <img className="w-full" src={banner.image_url} alt="" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default HeroSlider;
